import styled from 'styled-components';
export const Container = styled.div`
  flex-direction: column;
  width: 100%;
`;
export const Label = styled.div`
  ${_ref => {
  let {
    theme
  } = _ref;
  return theme.fonts.labelMD;
}}
  color: ${_ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.neutralL4;
}};
  margin-bottom: 8px;
  user-select: none;
`;
export const Divider = styled.div`
  height: 24px;
`;